import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { MapConfigurationDetails, StationAssignment } from '../../yard-map-configuration-model';

@Component({
    selector: 'app-station-assignment-details',
    templateUrl: './station-assignment-details.component.html',
    styleUrls: ['./station-assignment-details.component.scss'],
    standalone: false
})
export class StationAssignmentDetailsComponent implements OnInit {

  detailsForm: FormGroup;

  stationAssignment = null;

  @Input() configuration: MapConfigurationDetails;

  @Input() set assignment(assignment: StationAssignment) {
    this.stationAssignment = assignment;

    if (this.stationAssignment != null) {
      this.detailsForm.reset({ posX: assignment.x, posY: assignment.y });
      this.detailsForm.controls.posX.enable();
      this.detailsForm.controls.posY.enable();
    } else {
      this.detailsForm.reset({ posX: null, posY: null });
      this.detailsForm.controls.posX.disable();
      this.detailsForm.controls.posY.disable();
    }
  }

  @Output() stationAssignmentRemoved = new EventEmitter<StationAssignment>();

  constructor(
    public translationService: TranslationService
  ) {
    this.detailsForm = new FormGroup({
      posX: new FormControl(null, [Validators.required]),
      posY: new FormControl(null, [Validators.required]),
    });

    this.detailsForm.valueChanges.subscribe(
      value => {
        if (this.detailsForm.dirty && this.stationAssignment != null) {
          this.stationAssignment.x = this.detailsForm.controls.posX.value;
          this.stationAssignment.y = this.detailsForm.controls.posY.value;
          this.configuration.dirty = true;
        }
      }
    );
  }

  ngOnInit(): void {
  }

  public removeStationAssignment() {
    this.detailsForm.reset({ posX: null, posY: null });
    this.detailsForm.controls.posX.disable();
    this.detailsForm.controls.posY.disable();
    this.stationAssignmentRemoved.next(this.stationAssignment);
    this.stationAssignment = null;
  }

}
